import React from "react";

const LogoutConfirmModal = ({ showLogoutConfirm, setShowLogoutConfirm, handleConfirmLogout }) => {
  if (!showLogoutConfirm) return null;

  return (
    <>
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50" />
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="bg-white rounded-2xl p-6 w-[400px] shadow-xl">
          <h2 className="text-xl font-semibold text-center mb-6">
            Are you sure you want to logout?
          </h2>
          <div className="flex gap-4">
            <button
              onClick={() => setShowLogoutConfirm(false)}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirmLogout}
              className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
            >
              Yes, Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoutConfirmModal;
